import { render, staticRenderFns } from "./newfile.vue?vue&type=template&id=1c18843f"
import script from "./newfile.vue?vue&type=script&lang=js"
export * from "./newfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports